import axios from 'axios';
import server from '../serverUrl'
import { modal } from "../Components/ModalContext/ModalContext";
import { getApiErrorMessage, getUploadSizeErrorMessage, MAX_UPLOAD_SIZE_BYTES } from '../utils/fileHelpers';
const getToken = () => localStorage.getItem('token');
const apiBaseUrl = server.server

const normalizeUploadResponse = (data) => {
  if (!data || typeof data === 'string') return data;

  const firstFile = Array.isArray(data.files) ? data.files[0] : null;
  if (!firstFile) return data;

  return {
    ...data,
    Location: data.Location || firstFile.url || '',
    previewUrl: data.previewUrl || firstFile.previewUrl || firstFile.url || '',
    extension: data.extension || firstFile.extension || '',
    downloadUrl: data.downloadUrl || firstFile.url || data.Location || '',
  };
};

const getFilesFromFormData = (formData) => {
  if (!formData || typeof formData.entries !== 'function') return [];
  const files = [];
  for (const [, value] of formData.entries()) {
    if (value && typeof value === 'object' && typeof value.size === 'number') {
      files.push(value);
    }
  }

  return files;
};

const handleGetRequest = async (endpoint, navigate = null) => {
  const token = getToken();

  if (!token) {
    if (navigate) navigate('/login');
    return 'No authentication token found. Redirecting to login.';
  }

  try {
    const response = await axios.get(`${apiBaseUrl}/${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.message === 'Network Error') {
      modal.openModal("Network Error. Please check your internet connection.");
      // window.location.href = 'https://docity-user.netlify.app'
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message;

      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        if (navigate) navigate('/login');
        modal("jwt expired");

        return 'Session expired. Redirecting to login.';
      }

      return `Error: ${message || 'Request Failed'}`;
    }

    return 'Network error. Please try again.';
  }
};

const handleGetRequest2 = async (endpoint, navigate = null) => {
  // const token = getToken();

  // if (!token) {
  //   if (navigate) navigate('/login');
  //   return 'No authentication token found. Redirecting to login.';
  // }

  try {
    const response = await axios.get(`${apiBaseUrl}/${endpoint}`, {
      // headers: {
      //   'Authorization': `Bearer ${token}`,
      // },
    });
    return response.data;
  } catch (error) {
    if (error.message === 'Network Error') {
      modal.openModal("Network Error. Please check your internet connection.");
      // window.location.href = 'https://docity-user.netlify.app'
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message;

      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        if (navigate) navigate('/login');
        modal("jwt expired");

        return 'Session expired. Redirecting to login.';
      }

      return `Error: ${message || 'Request Failed'}`;
    }

    return 'Network error. Please try again.';
  }
};
const handleRequest = async (endpoint, formData, navigate = null) => {
  const token = getToken();

  if (!token) {
    if (navigate) navigate('/login');
    return 'No authentication token found. Redirecting to login.';
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.message === 'Network Error') {
      // alert('Network Error');
      modal.openModal("Network Error. Please check your internet connection.");

      // window.location.href = 'https://docity-user.netlify.app'
      return 'Error: Network Error - Redirecting to login';
    }

    if (error.response) {
      const status = error.response.status;
      const message = error.response.data.message;

      if ((status === 401 && message?.includes('jwt expired')) || message?.includes('TokenExpiredError')) {
        if (navigate) navigate('/login');
        // alert('jwt expired');

        modal("jwt expired");
        return 'Session expired. Redirecting to login.';
      }

      return `Error: ${message || 'Request Failed'}`;
    }

    return 'Network error. Please try again.';
  }
};
const getSectionFromUrl = () => {
  const hash = window.location.hash || '';
  if (hash.includes('/requestProperty')) return 'Dcp/formDocuments';
  if (hash.includes('/reqProperty')) return 'Dcp/chatDocuments';
  if (hash.includes('/soc')) return 'Soc/documents';
  if (hash.includes('/kyp')) return 'Kyp/formDocuments';
  if (hash.includes('/KYPList')) return 'Kyp/landUseDocuments';

  const path = window.location.pathname || '';
  if (path.includes('requestProperty')) return 'Dcp/formDocuments';
  if (path.includes('reqProperty')) return 'Dcp/chatDocuments';
  if (path.includes('soc')) return 'Soc/documents';
  if (path.includes('kyp')) return 'Kyp/formDocuments';
  if (path.includes('KYPList')) return 'Kyp/landUseDocuments';

  return 'Dcp/formDocuments';
};

//File Upload
const handleFileUpload = async (endpoint, formData, navigate = null, propertyContext = null) => {
  const token = getToken();

  if (!token) {
    return 'No authentication token found.';
  }

  const oversizedFile = getFilesFromFormData(formData).find((file) => file.size > MAX_UPLOAD_SIZE_BYTES);
  if (oversizedFile) {
    const message = getUploadSizeErrorMessage(oversizedFile.name || 'File');
    return `Error: ${message}`;
  }

  const section = (propertyContext && propertyContext.section) || getSectionFromUrl();

  const headers = {
    'Authorization': `Bearer ${token}`,
    'x-docity-section': section,
  };

  // Pass property identifiers so all uploads for the same property go to the same S3 folder
  if (propertyContext) {
    if (propertyContext.propertyId) {
      headers['x-docity-propertyid'] = propertyContext.propertyId;
    }
    if (propertyContext.propertyName) {
      headers['x-docity-propertyname'] = propertyContext.propertyName;
    }
    if (propertyContext.propertyKey) {
      headers['x-docity-propertykey'] = propertyContext.propertyKey;
    }
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
      headers,
    });
    return normalizeUploadResponse(response.data);
  } catch (error) {
    const message = getApiErrorMessage(
      error,
      error?.message === 'Network Error'
        ? 'Unable to upload file. Please check your internet connection, backend CORS, or file size.'
        : 'Upload failed. Please try again.'
    );

    return `Error: ${message}`;
  }
};
const handleLogout = (navigate) => {
  localStorage.clear()
  navigate("/");
  window.location.reload();
};


const PropertiesService = {
  requestProperty: (formData, navigate) => handleRequest('requestProperty', formData, navigate),
  verifyProperty: (formData, navigate) => handleRequest('verifyProperty', formData, navigate),
  getUserProperties: (formData, navigate) => handleRequest('getUserProperties', formData, navigate),
  getPropertyData: (navigate) => handleGetRequest('getAllProperties', navigate),
  getAllDocs: (navigate) => handleGetRequest('getAllDocs', navigate),
  getMandalList: (navigate) => handleGetRequest('mandalsList', navigate),
  getQuestions: (navigate) => handleGetRequest('getQuestions', navigate),
  UploadFiles: (formData, navigate, propertyContext = null) => handleFileUpload('MultipleFileUpload', formData, navigate, propertyContext),
  EncryptPdf: (formData, navigate) => handleFileUpload('EncryptPdf', formData, navigate),
  uploadDoc: (formData, navigate) => handleRequest('addDocument', formData, navigate),
  updateDocument: (formData, navigate) => handleRequest('UpdateDocument', formData, navigate),
  verifyPropertyAndAssignCivilEngineer: (formData, navigate) => handleRequest('verifyPropertyAndAssignCivilEngineer', formData, navigate),
  getDocs: (formData, navigate) => handleRequest('getDocs', formData, navigate),
  getSignleProperty: (formData, navigate) => handleRequest('getSignleProperty', formData, navigate),
  getdoCityUsers: (navigate) => handleGetRequest2('getAllDoCityUsers', navigate),
  createPaymentOrder: (formData, navigate) => handleRequest('createPaymentOrder', formData, navigate),
  UpdateProperty: (formData, navigate) => handleRequest('UpdateProperty', formData, navigate),
  getKpiLists: (formData, navigate) => handleRequest('getKypListswithuserId', formData, navigate),
  getAllDepartments: (navigate) => handleGetRequest('getAllDepartments', navigate),
  editkyp: (formData, navigate) => handleRequest('EditKnowYourProperty', formData, navigate),
  saveContactUsDetails: (formData, navigate) => handleRequest('saveContactUsDetails', formData, navigate),
  getAssignedEngineer: (formData, navigate) => handleRequest('getAssignedEngineer', formData, navigate),
  getFAQS: (navigate) => handleGetRequest('getFAQS', navigate),
  editCivilEngData: (formData, navigate) => handleRequest('editCivilEngData', formData, navigate),
  DeleteProperty: (formData, navigate) => handleRequest('DeleteProperty', formData, navigate),
  KnowYourProperty: (formData, navigate) => handleRequest('KnowYourProperty', formData, navigate),
  getAddressByPincode: (formData, navigate) => handleRequest('getAddressByPincode', formData, navigate),
  getAllStatesList: (formData, navigate) => handleRequest('getAllStatesList', formData, navigate),
  getAllProperties: (navigate) => handleGetRequest('getAllProperties', navigate),
  sendAlertToAdminAfterThreeSaledeedRejections: (formData, navigate) => handleRequest('sendAlertToAdminAfterThreeSaledeedRejections', formData, navigate),
  generateoc: (formData, navigate) => handleRequest('generate-oc', formData, navigate),
  generatesoc: (formData, navigate) => handleRequest('generateso', formData, navigate),
  updateSoc: (formData, navigate) => handleRequest('UpdateSoc', formData, navigate),
  updateKnowYourProperty: (formData, navigate) => handleRequest('UpdateKnowYourProperty', formData, navigate),

  handleLogout,
};

export default PropertiesService;

